import "/home/user/.rbenv/versions/3.3.0/lib/ruby/gems/3.3.0/bundler/gems/billing-dda56174042f/app/javascript/src/billing/omniForm"
import "/home/user/.rbenv/versions/3.3.0/lib/ruby/gems/3.3.0/bundler/gems/billing-dda56174042f/app/javascript/src/billing/cardSetupForm"
import "/home/user/.rbenv/versions/3.3.0/lib/ruby/gems/3.3.0/bundler/gems/billing-dda56174042f/app/javascript/src/billing/paymentConfirmation"

// Docs: https://stripe.com/docs/js/elements_object/create_element?type=card#elements_create-options
// Also see 'app/javascript/stylesheets/billing.scss' for overrides.
window.billingCardElementOptions.classes = {
  base: "mt-6 appearance-none px-3 border border-gray-300 rounded-md shadow-sm billing-card-element-base",
  complete: "billing-card-element-complete",
  empty: "billing-card-element-empty",
  focus: "outline-none ring-2 ring-blue-500 border-transparent billing-card-element-focus",
  invalid: "border-red-300 billing-card-element-invalid",
  disable: "bg-gray-50 cursor-not-allowed",
  webkitAutofill: "billing-card-element-webkit-autofill"
}

// https://stripe.com/docs/js/appendix/style?type=card
window.billingCardElementOptions.style = {
  base: {
    ":disabled": {
      color: "#111827" // gray 900
    }
  }
}
